import { useState } from 'react';

import webview from '@adapter/webview';
import { ArrowBack } from '@groww-tech-pvt/icon-store/mi';

import { ONBOARDING_FLOW_SCREENS } from 'core/constants';
import useOnboardingStore from 'core/store';
import { getDomainConfig, getIsDomain915 } from 'src/utils/config/domainConfig';
import { useRedirectToPreviousPage } from 'src/utils/hook';

import { Header915 } from './Header915';
import OnboardingBackPopup from './OnboardingBackPopup';
import OnbImage from 'src/components/Image';
import { ONBOARDING_IMAGES } from 'core/assets';
import { ToastContainer } from 'src/components/Toast';

const OnboardingProvider = ({ children }: { children: React.ReactNode }) => {
  const WV = webview();
  const isMsite = typeof window !== 'undefined' && window.innerWidth < 768;
  const domain = getDomainConfig();
  const isDomain915 = getIsDomain915();
  const [isExitPopupOpen, setIsExitPopupOpen] = useState(false);
  const activeScreen = useOnboardingStore(s => s.activeScreen);
  const hideHistoryBackPopup = useOnboardingStore(s => s.hideHistoryBackPopup);
  const { goBackToPreviousPage } = useRedirectToPreviousPage('BACK_POPUP');

  const skipExitIntercept =
    activeScreen === ONBOARDING_FLOW_SCREENS.SUCCESS_SCREEN ||
    activeScreen === ONBOARDING_FLOW_SCREENS.ONBOARDING_PENDING_SCREEN ||
    hideHistoryBackPopup;

  const onBackClick = () => {
    if (skipExitIntercept) {
      goBackToPreviousPage();
      return;
    }
    setIsExitPopupOpen(true);
  };

  const getHeader = () => {
    switch (domain.appId) {
      case 'GrowwWeb':
        return (
          <div className="w-full flex py-4 pl-3 px-5 justify-between absolute top-0 stretch z-1">
            {WV.isActive || isMsite ? (
              <ArrowBack
                color="contentPrimary"
                size={22}
                onClick={onBackClick}
              />
            ) : (
              <OnbImage
                src={ONBOARDING_IMAGES.GROWW_LOGO}
                width={'auto'}
                height={'auto'}
                className="h-[4vh] min-h-0.5 cursor-pointer "
                onClick={onBackClick}
              />
            )}
          </div>
        );
      case '915Web':
        return <Header915 />;

      default:
        return <></>;
    }
  };

  return (
    <div className={`relative flex flex-col min-h-screen overflow-hidden`}>
      <OnbImage
        src={ONBOARDING_IMAGES.PATTERN_BG}
        width={100}
        height={100}
        className={`w-full h-full object-cover absolute bottom-0 left-0 blur-[1px] ${!isDomain915 ? 'backgroundPrimary' : ''}`}
      />

      {getHeader()}
      <div className="absolute top-[6%] md:top-13.5 lg:top-[10%] inset-x-0 flex justify-center">
        <div
          className={`lg:w-210 md:w-155 w-full
           sm:w-[80%] sm:backdrop-blur-xl lg:p-5 p-3 sm:pt-3 sm:mt-16 rounded-lg!
           h-[94vh] md:h-[70vh] lg:h-[70vh] sm:h-225 ${!isDomain915 ? 'backgroundSecondary glass' : 'backgroundPrimary gradient-bg glass'} overflow-y-auto`}
        >
          {children}
        </div>
      </div>

      <OnboardingBackPopup
        isExitPopupOpen={isExitPopupOpen}
        setIsExitPopupOpen={setIsExitPopupOpen}
      />
      <ToastContainer />
    </div>
  );
};

export default OnboardingProvider;
